import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const keyContext = createContext();

function KeyContextProvider(props) {
  const key = sessionStorage.getItem("key");
  let orgID = sessionStorage.getItem("orgID");

  const [data, setData] = useState([]);
  const [dagsData, setDagsData] = useState([]);
  const [dagensData, setDagensData] = useState([]);
  const [open, setOpen] = useState(false);
  const [dagensSelectedDate, setDagensSelectedDate] = useState("");
  const [dagensNextDay, setDagensNextDay] = useState("");
  const [dagsFilm, setDagsFilm] = useState("");
  const [defaultFilm, setDefaultFilm] = useState("");
  const [filmId, setFilmId] = useState("");
  const [networkError, setNetworkError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isChecked, setIsChecked] = useState(localStorage.getItem("burgerMenuChecked") === "true" ? true : false );
  const [selectAllFilmAtOnce, setSelectAllFilmAtOnce] = useState(false)
  const [clickedMovieDiv, setClickedMovieDiv] = useState();
  const [moviesSelected, setMoviesSelected ] = useState(false)
  const [isSoldChecked, setIsSoldChecked] = useState(true);
  const [anyMovieSelected, setAnyMovieSelected ] = useState(false)
  const [distributorsName, setDistributorsName] = useState('');
  const [commitModal, setCommitModal] = useState(false);
  const [programmedDates,setProgrammedDates] = useState([])
  const [eventsChanged, setEventsChanged] = useState(false);
  const [isTicketChecked, setIsTicketChecked] = useState( true );
  const [isKioskChecked, setIsKioskChecked] = useState(true );
  const [isAndenChecked, setIsAndenChecked] = useState(true );
  const [isSamletChecked, setIsSamletChecked] = useState(true);
  const [isKioskOmsChecked, setIsKioskOmsChecked] = useState(true );
  const [filmBioChanged, setFilmbiochanged] = useState(false);
  const [chosenCinema, setChosenCinema] = useState(false);
  const [orgSelect, setOrgSelect] = useState( sessionStorage.getItem('programOrg') ?  sessionStorage.getItem('programOrg') : '' );
  const [movieNumber, setMovieNumber] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(sessionStorage.getItem('program_date') ? new Date(sessionStorage.getItem('program_date')) :  new Date());
  const [weekBoxOpen, setWeekBoxOpen] = useState(false)
  const [containerHeight, setContainerHeight] = useState('')
  const [leftSpace,setLeftSpace] = useState('')
  const [leftMargin, setLeftMargin] = useState('')
  const [calendarShow, setCalendarShow] = useState(false)
  const [arrTypes, setArrTypes] = useState([])
  const [allTicketTypes, setAllTicketTypes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false)
  const [deletebtnclk, setDeletebtnclk] = useState(false)
  const [dateChosen, setDateChosen] = useState(false)
  const [webEditing, setWebEditing] = useState(false);
  const [editedEvId, setEditedEvId] = useState();
  const [divOpened, setDivOpened]   = useState(false);
  const [savebtnclk, setSavebtnclk] = useState(false);
  const [alertEvents, setalertEvents] = useState();
  const [allzero, setAllzero] = useState(false);
  const [allOne, setAllOne] = useState(false);
  const [eventEdit, seteventEdit] = useState(false);
  const [eventSaveObj, setEventSaveObj] = useState()
  const [titleChanged, setTitleChanged] = useState(false);
  const [showGrunddataModal, setShowGrunddataModal] = useState(false);
  const [selectedFilmId, setSelectedFilmId] = useState(0);
  const [titleNotSaved, setTitleNotSaved] = useState(false);
  const [visualDivHeight, setVisualDivHeight] = useState();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorNo, setErrorNo] = useState();
  const [errorText, setErrorText] = useState('');
  const [clkdMovieName, setClkdMovieName] = useState('')
  const [programRights, setProgramRights] = useState([])
  const [showFilm, setShowFilm]   = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [waitingModal, setWaitingModal] = useState(false);
  const [apiLoader, setApiLoader] = useState(false);
  const [errorStatus, setErrorStatus] = useState();
  const [errorType, setErrorType] = useState();
  const [changesLeft, setChangesLeft] = useState();
  const [changes, setChanges] = useState();
  const [eventErrorModal, setEventErrorModal] = useState(false);

  let flag = false 
  let default_filmID = sessionStorage.getItem('default-filmID')
  let ge = sessionStorage.getItem('programOrg')

  let org = ge && ge.split(" ")[ge.split(" ").length - 1]

  // man_event_push_check call
 function eventPushCheck () {  
       setWaitingModal(true)
       setCommitModal(true)
      
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_push_check` ,{
        method: "POST",     
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',     
       },
       body:`Key=${key}&orgNo=${default_filmID ? default_filmID : org}`
   })
    .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setCommitModal(false)
          setWaitingModal(false)
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
         if(result.Result === 0) {
          logOut()
          
         }
         setWaitingModal(false)
         setApiLoader(false)
         setChanges(result.ChangesLeft)
         setChangesLeft(result.ChangesLeft)
      if(result.ChangesLeft === 0) {
        //  setCommitModal(false)
        window.location.reload()
      }
      })
       
        
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)
               console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
}
  
  function logOut() {
    console.log('log out from key context')
    sessionStorage.removeItem("key");
    sessionStorage.removeItem("period");
    sessionStorage.removeItem("film");
    sessionStorage.removeItem("default-filmID");
    sessionStorage.removeItem("orgID");
    sessionStorage.setItem('programRight',false)
    sessionStorage.removeItem('programOrg')
    sessionStorage.removeItem('filmRight')
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('password')
    sessionStorage.removeItem('program_date')
   // sessionStorage.removeItem('selected-date')

    setData("");
    setDagsData("");
    setDagensData("");
    
    window.location.reload();
  }
  
  return (

    

    <keyContext.Provider
      value={{
        eventErrorModal, setEventErrorModal,
        programmedDates,setProgrammedDates,
        logOut, changes,changesLeft, setChangesLeft,eventPushCheck,
        isKioskChecked, setIsKioskChecked,
        isKioskOmsChecked, setIsKioskOmsChecked,
        isSamletChecked, setIsSamletChecked,
        isAndenChecked, setIsAndenChecked,
        isTicketChecked, setIsTicketChecked,
        isSoldChecked, setIsSoldChecked,
        isChecked,   setIsChecked,
        dagensNextDay,  setDagensNextDay,
        dagensSelectedDate,   setDagensSelectedDate,
        open,    setOpen,
        dagensData,   setDagensData,
        defaultFilm,    setDefaultFilm,
        networkError,
        dagsFilm,    setDagsFilm,
        dagsData,      setDagsData,
        data,      setData,
        userName,    setUserName,
        password,      setPassword,
        movieNumber,      setMovieNumber,
        startDate,      setStartDate,
        endDate,       setEndDate,
        filmId,      setFilmId,
        errorMessage,
        selectAllFilmAtOnce,  setSelectAllFilmAtOnce,
        selectedDate,   setSelectedDate,
        weekBoxOpen, setWeekBoxOpen,
        containerHeight, setContainerHeight,
        leftSpace,setLeftSpace,
        chosenCinema, setChosenCinema,
        leftMargin, setLeftMargin,
        orgSelect, setOrgSelect,
        calendarShow, setCalendarShow,
        arrTypes, setArrTypes,
        allTicketTypes, setAllTicketTypes,
        modalOpen, setModalOpen,
        moviesSelected, setMoviesSelected,
        deletebtnclk, setDeletebtnclk,
        dateChosen, setDateChosen,
        anyMovieSelected, setAnyMovieSelected ,
        webEditing, setWebEditing,
        editedEvId, setEditedEvId,
        divOpened, setDivOpened,
        savebtnclk, setSavebtnclk,
        allzero, setAllzero,
        allOne, setAllOne,
        alertEvents, setalertEvents,
        eventEdit,seteventEdit,
        eventsChanged,setEventsChanged,
        eventSaveObj, setEventSaveObj,
        titleChanged, setTitleChanged,
        showGrunddataModal, setShowGrunddataModal,
        selectedFilmId, setSelectedFilmId,
        titleNotSaved, setTitleNotSaved,
        visualDivHeight, setVisualDivHeight,
        showErrorModal, setShowErrorModal,
        errorNo, setErrorNo,
        errorText, setErrorText,
        distributorsName, setDistributorsName,
        filmBioChanged, setFilmbiochanged,
        clkdMovieName, setClkdMovieName,
        programRights, setProgramRights,
        showFilm, setShowFilm,
        showDropdown, setShowDropdown,
        clickedMovieDiv, setClickedMovieDiv,
        waitingModal, setWaitingModal,
        apiLoader, setApiLoader,
        errorStatus, setErrorStatus,
        errorType, setErrorType,
        commitModal, setCommitModal
      }}
    >
      {props.children}
    </keyContext.Provider>
  );
}

export default KeyContextProvider;
